<template>
  <el-card style="margin-bottom: 50px">
    <div class="add-microshop-goods-container">
      <hm-step
        :scroll="true"
        :steps="steps"
        @scroll="windowScroll"
        :step="currentStep"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="商品货号：" prop="goodsSn">
              <el-input
                size="small"
                class="mr10 ipt"
                :show-message="showGoodsSn"
                v-model.trim="ruleForm.goodsSn"
                placeholder="请选择商品货号"
                readonly
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" prop="wxshopSpuName">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.wxshopSpuName"
                placeholder="例如：农夫山泉矿泉水550ml"
              ></el-input>
              <el-button type="text" @click="importDialogVisible = true"
                >快速导入京东商品信息（限时免费）</el-button
              >
            </el-form-item>
            <el-form-item
              label="商品分类："
              class="is-required"
              prop="category"
            >
              <el-cascader
                v-model="ruleForm.categoryRelModelList"
                :show-message="isShowCategoryErr"
                :show-all-levels="false"
                size="small"
                :props="categoryFunc"
                ref="cascader"
                clearable
              ></el-cascader>
              <el-button
                class="btn"
                size="small"
                @click="toUrl('MicroShopGoodsCate')"
                icon="hmicon icon-hao"
                >新建分类</el-button
              >
              <div class="form-item-tip">
                此分类为微店商品分类，商品分类用于手机端显示商品分类
              </div>
            </el-form-item>
            <el-form-item label="商品类型：" class="is-required">
              <el-radio-group
                @change="switchGoodsType"
                v-model="ruleForm.spuType"
                :disabled="isThird"
              >
                <el-radio label="reality">
                  实物商品
                  <span class="form-item-tip">需要发货</span>
                </el-radio>
                <el-radio label="virtual">
                  虚拟商品
                  <span class="form-item-tip">无需发货</span>
                </el-radio>
              </el-radio-group>
              <div class="form-item-tip">商品类型一旦选择，不可更改</div>
              <div v-if="ruleForm.spuType === 'virtual'">
                <div class="flex item-center">
                  <span class="mr10">虚拟商品售后</span>
                  <el-radio-group v-model="ruleForm.memberLaunchRefund">
                    <el-radio label="no">不支持买家申请退款</el-radio>
                    <el-radio label="yes">支持买家申请退款</el-radio>
                  </el-radio-group>
                </div>
                <div class="form-item-tip">
                  商品详情页将展示“不支持申请退款的说明”，买家只能主动联系商家处理
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="是否海外商品："
              prop="isOverseas"
              v-if="showOverseas"
            >
              <el-radio-group
                v-model="ruleForm.isOverseas"
                @change="isOverseasChange"
                :disabled="!!ruleForm.isOverseas"
              >
                <el-radio label="yes">
                  是
                </el-radio>
                <el-radio label="no">
                  否
                </el-radio>
              </el-radio-group>
              <div class="form-item-tip">
                  海外购商品显示全球购标签，非海外购商品显示自营标签
              </div>
            </el-form-item>
            <el-form-item
              label="原产地："
              prop="prodPlaceId"
              v-if="ruleForm.isOverseas === 'yes'"
            >
              <el-select
                size="small"
                v-model="ruleForm.prodPlaceId"
                filterable
                clearable
                placeholder="请选择原产地"
              >
                <el-option
                  :label="v.nameZh"
                  :value="v.id"
                  v-for="(v, i) in prodPlaceList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="发货方式："
              prop="deliveryType"
              v-if="ruleForm.isOverseas === 'yes'"
            >
              <el-radio-group v-model="ruleForm.deliveryType">
                <el-radio label="bondedAreaDeliver">
                  保税区发货
                </el-radio>
                <el-radio label="overseasMail">
                  海外直邮
                </el-radio>
              </el-radio-group>
              <div v-if="ruleForm.deliveryType === 'bondedAreaDeliver'">
                <el-select
                  size="small"
                  v-model="ruleForm.bondedAreaId"
                  filterable
                  class="mr10"
                  clearable
                  placeholder="请选择保税区"
                >
                  <el-option
                    :label="v.bondedAreaName"
                    :value="v.id"
                    v-for="(v, i) in bondedAreaList"
                    :key="i"
                  ></el-option>
                </el-select>
                <el-button type="text" size="small" @click="addBondedArea"
                  >新增保税区</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="税费："
              prop="feeRatio"
              v-if="ruleForm.isOverseas === 'yes'"
            >
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0OrFixed2('feeRatio')"
                v-model.trim="ruleForm.feeRatio"
                placeholder="请输入税费"
              ></el-input
              >%
              <div class="form-item-tip">
                代表海外购商品到消费者手上需要的整体税收比例，将在订单结算的时候计算在结算金额中
              </div>
            </el-form-item>
            <el-form-item
              label="商品预购："
              class="is-required"
              prop="overstockSalesMode"
            >
              <el-switch
                v-model="ruleForm.overstockSales"
                active-text="开启"
                inactive-text="关闭"
                active-color="#13ce66"
                active-value="open"
                inactive-value="close"
                :disabled="isThird"
              ></el-switch>
              <div class="form-item-tip">
                预购关闭，则库存按照实际库存出；预购开启则商品按照预购库存出
              </div>
              <div
                class="flex item-center"
                v-if="ruleForm.overstockSales === 'open'"
              >
                <span class="mr10">预购开启</span>
                <el-radio-group v-model="ruleForm.overstockSalesMode">
                  <el-radio label="date">
                    <el-date-picker
                      :disabled="ruleForm.overstockSalesMode !== 'date'"
                      v-model="ruleForm.deliveryDeadline"
                      type="datetime"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开售时间"
                      size="small"
                      class="mr10"
                    ></el-date-picker
                    >
                    <el-select size="small" style="width:80px" v-model="around" placeholder="请选择">
                      <el-option
                        v-for="item in arounds"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    发货
                  </el-radio>
                  <el-radio label="day">
                    付款成功
                    <el-input
                      :disabled="ruleForm.overstockSalesMode !== 'day'"
                      size="small"
                      clearable
                      style="width: 80px"
                      class="mr10 ipt"
                      @input="filterGt0('afterPayDays')"
                      maxlength="2"
                      v-model.trim="ruleForm.afterPayDays"
                    ></el-input
                    >天后发货
                  </el-radio>
                </el-radio-group>
              </div>
              <div
                class="form-item-tip primary"
                v-if="ruleForm.overstockSales === 'open'"
              >
                注意：只允许设置0-90天内发货，请务必按照约定时间发货，以免引起客户投诉，当设置为0，手机端不显示
              </div>
            </el-form-item>
            <el-form-item label="是否允许使用优惠券" prop="couponUsable">
              <el-tooltip
                class="item"
                effect="dark"
                content="一旦设置为禁止使用，则不参加任何用券"
                placement="top"
              >
                <el-switch
                  v-model="ruleForm.couponUsable"
                  active-text="允许"
                  inactive-text="禁止"
                  active-color="#13ce66"
                  active-value="yes"
                  inactive-value="no"
                  :disabled="isThird"
                >
                </el-switch>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="是否允许使用储值卡" prop="prepayCardUsable">
              <el-switch
                v-model="ruleForm.prepayCardUsable"
                active-text="允许"
                inactive-text="禁止"
                active-color="#13ce66"
                active-value="yes"
                inactive-value="no"
                :disabled="isThird"
                @change="prepayCardUsableChange"
              >
              </el-switch>
              <div class="form-item-tip">如果禾苗系统的订单会同步到第三方的系统，请保持第三方系统中的商品与禾苗系统中一致</div>
            </el-form-item>
            <el-form-item label="是否写入POS" prop="writePosUsable" v-if="this.ruleForm.writePosUsable != null" >
              <el-switch
                  v-model="ruleForm.writePosUsable"
                  active-text="允许"
                  inactive-text="禁止"
                  active-color="#13ce66"
                  active-value="yes"
                  inactive-value="no"
                  :disabled="isThird"
              >
              </el-switch>
              <div class="form-item-tip">如果禾苗系统的订单会同步到第三方的系统，请保持第三方系统中的商品与禾苗系统中一致</div>
            </el-form-item>
            <el-form-item label="商品净重：">
              <el-input
                v-model.trim="ruleForm.netWeight"
                @input="filterGt0OrFixed2('netWeight')"
                class="mr10"
                size="small"
                type="number"
                style="width: 80px"
                :disabled="isThird"
              ></el-input>
              <el-select
                style="width: 100px"
                size="small"
                class="auto-width-select"
                v-model="ruleForm.weightUnit"
                placeholder="请选择商品净重"
                :disabled="isThird"
              >
                <el-option label="克" value="g"></el-option>
                <el-option label="千克" value="kg"></el-option>
              </el-select>
              <div class="form-item-tip">
                商品重量应用到计算与重量相关的配送方式计价
              </div>
            </el-form-item>
            <el-form-item label="商品卖点：">
              <el-input
                size="small"
                v-model="ruleForm.sellingPoint"
                type="textarea"
                maxlength="50"
                placeholder="请输入商品卖点"
              ></el-input>
              <div class="form-item-tip">
                在商品详情标题下显示卖点信息，也是分享给好友时显示的卖点信息，建议50字以内
              </div>
            </el-form-item>
            <el-form-item label="主图：">
              <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!ruleForm.spuMainPic"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片注意：
                    <div>
                      1.主图仅可设置一张
                    </div>
                    <div>
                      2.图片尺寸建议750x750
                    </div>
                  </div>
                </div>
              </el-upload>
              <div class="priview" v-if="ruleForm.spuMainPic">
                <img :src="ruleForm.spuMainPic" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="分享图：">
              <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadSharePicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!ruleForm.sharePic"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片注意：
                    <div>
                      1.分享图仅可设置一张
                    </div>
                    <div>
                      2.图片尺寸建议500x400
                    </div>
                  </div>
                </div>
              </el-upload>
              <div class="priview priviewSharePic" v-if="ruleForm.sharePic">
                <img :src="ruleForm.sharePic" alt="分享图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemoveSharePic">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="轮播组图：" prop="listDetail">
              <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="showDetail"
                noCircle
                noSquare
                :width="750"
                :height="750"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'goodsCenter' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <el-button
                type="primary"
                size="small"
                v-show="ruleForm.spuSlideShowPicList.length < 6"
                @click="toggleShowDetail"
                >上传</el-button
              >
              <span class="form-tip"
                >（列表详情图可设置6张，图片尺寸建议750x750，已经发布到微店的商品图，只需要在微店商品信息中修改，此时商品库的商品图修改不影响）</span
              >-->
              <el-upload
                v-show="ruleForm.spuSlideShowPicList.length < 6"
                class="upload flex"
                ref="elupload"
                :limit="6"
                drag
                multiple
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccesss"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片/视频拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片/视频注意：
                    <div>
                      1.图片尺寸建议750x750
                    </div>
                    <div>
                      2.图片格式：png、jpg、bmp，视频格式：mp4,且不得超过10M
                    </div>
                    <div>
                      3.轮播图可设置6张,视频可设置1个
                    </div>
                    <div>
                      4.轮播图可以拖拽调整顺序
                    </div>
                  </div>
                </div>
              </el-upload>
              <draggable
                :list="ruleForm.spuSlideShowPicList"
                class="flex flex-wrap"
              >
                <div
                  class="priview mr10"
                  v-show="v"
                  v-for="(v, i) in ruleForm.spuSlideShowPicList"
                  :key="i"
                >
                  <el-image
                    style="height: 100%;width:100%"
                    :src="v"
                    v-if="v.indexOf('.mp4') === -1 && v.indexOf('.MP4') === -1"
                    :preview-src-list="ruleForm.spuSlideShowPicList"
                  ></el-image>
                  <video class="video" controls :src="v" v-else></video>
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="setFirst(i)"
                      >设为第一张图</el-button
                    >
                    <el-button
                      type="text"
                      v-if="
                        v.indexOf('.mp4') === -1 && v.indexOf('.MP4') === -1
                      "
                      @click="setMainPic(i)"
                      >设为主图</el-button
                    >
                    <el-button type="text" @click="handleRemoveListDetail(i)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </draggable>
            </el-form-item>
            <el-form-item label="图文详情：">
              <hm-rich-editor
                v-model="ruleForm.spuDetails"
                :html="ruleForm.spuDetails"
              />
            </el-form-item>
            <div id="specification">2.规格/库存信息</div>
            <el-form-item
              label="规格信息"
              class="is-required"
              prop="skuModelList"
              v-if="ruleForm.skuModelList.length"
            >
              <div class="table" v-show="ruleForm.skuModelList.length">
                <div class="table-control flex flex-end">
                  <el-checkbox-group
                    v-model="batchSettingPic"
                    :disabled="isThird"
                    class="mr10"
                    @change="batchSettingPicChange"
                  >
                    <el-checkbox
                      v-for="(v, i) in batchSettingPicList"
                      :label="v.value"
                      :key="i"
                      :disabled="isThird"
                      >同{{ruleForm.skuModelListCopy[0].specName}}规格使用同一图片</el-checkbox
                    >
                  </el-checkbox-group>
                  <el-input
                    class="mr10"
                    v-model="wxshopStockNum"
                    @input="filterGt0OrFixed2ByData('wxshopStockNum')"
                    size="small"
                    style="100px"
                    placeholder="输入可售库存"
                    :disabled="isThird"
                  ></el-input>
                  <el-input
                    class="mr10"
                    v-model="wxshopPrice"
                    @input="filterGt0OrFixed2ByData('wxshopPrice')"
                    size="small"
                    style="100px"
                    placeholder="输入零售价"
                    :disabled="isThird"
                  ></el-input>
                  <div class="pointer" @click="batchSetting">
                    <span class="delete-icon hmicon icon-xitong"></span>
                    批量设置
                  </div>
                </div>
                <div class="table-body">
                  <div class="table-row flex item-center">
                    <div
                      class="flex-1 text-center"
                      v-for="(v, i) in ruleForm.skuModelListCopy"
                      :key="i"
                    >
                      {{ v.specName }}
                    </div>
                    <div class="flex-1 text-center">网店售价</div>
                    <div class="flex-1 text-center">可售库存</div>
                    <div class="flex-1 text-center">条码</div>
                    <div class="flex-1 text-center">规格图片</div>
                    <div class="flex-1 text-center">起售限制(方式)</div>
                    <div class="flex-1 text-center">起售限制(数量)</div>
                    <div class="flex-1 text-center">操作</div>
                  </div>
                  <draggable :list="ruleForm.skuModelList">
                    <div
                      class="table-row flex item-center move"
                      v-for="(v, i) in ruleForm.skuModelList"
                      :key="i"
                    >
                      <div
                        class="flex-1 text-center pointer"
                        v-for="(item, index) in v.specValueList"
                        :key="index"
                        @dblclick="copy(item.specValue)"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="双击复制文字"
                          placement="top"
                        >
                          <span>{{ item.specValue }}</span>
                        </el-tooltip>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <!-- <el-input  size="small" v-model="v.wxshopPrice"></el-input> -->
                        <div
                          class="el-input el-input el-input--small"
                          style="width: 100px"
                        >
                          <input
                            class="el-input__inner"
                            size="small"
                            v-model="v.wxshopPrice"
                            :disabled="isThird"
                          />
                        </div>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <div
                          class="el-input el-input el-input--small"
                          style="width: 100px"
                        >
                          <input
                            class="el-input__inner"
                            size="small"
                            v-model="v.stockNum"
                            :disabled="isThird"
                          />
                          <!-- <el-input  size="small" v-model="v.markingPrice"></el-input> -->
                        </div>
                      </div>

                      <div
                        class="flex-1 flex flex-center pointer"
                        @dblclick="copy(v.specBarCode)"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="双击复制文字"
                          placement="top"
                        >
                          <span>{{ v.specBarCode }}</span>
                        </el-tooltip>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <div
                          class="flex upload-upload-btn"
                          @click="addwxshopSkuPic(v, 'wxshopSkuPic')"
                          v-if="!v.hidePic"
                        >
                          <div
                            class="btn flex flex-column flex-center open-file"
                            v-if="!v.wxshopSkuPic"
                          >
                            <div class="add-wrapper">
                              <span class="hmicon icon-hao pointer"></span>
                            </div>
                            <span>添加图片</span>
                          </div>
                          <div v-if="v.wxshopSkuPic" class="mr10 flex item-end">
                            <img
                              class="logo"
                              :src="v.wxshopSkuPic"
                              alt="logo"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <div
                          class="el-input el-input el-input--small"
                          style="width: 100px"
                        >
                        <el-radio-group
                          v-model="v.sellsLimitMode"
                          @change="skuModelListSellsLimitModeChange(v)"
                        >
                          <el-radio label="singleAdd" class="mt10">
                            单个递加
                          </el-radio>
                          <el-radio label="circleAdd" class="mt10">
                            循环递加
                          </el-radio>
                        </el-radio-group>
                        </div>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <div
                          class="el-input el-input el-input--small"
                          style="width: 100px"
                        >
                          <input
                            class="el-input__inner"
                            size="small"
                            v-model="v.sellsLimitNum"
                            placeholder="请输入起售数量限制"
                          />
                        </div>
                      </div>
                      <div class="flex-1 flex flex-center">
                        <el-checkbox
                          @change="setBindState(v)"
                          class="mr10"
                          v-model="v.bindState"
                          >关联</el-checkbox
                        >
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="可售库存"
              prop="stockNum"
              v-if="
                !ruleForm.skuModelList.length &&
                  ruleForm.overstockSales === 'open'
              "
            >
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                v-model.trim="ruleForm.stockNum"
                placeholder="请选择可售库存"
                :disabled="isThird"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="网店售价"
              prop="wxshopPrice"
              v-if="!ruleForm.skuModelList.length"
            >
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0OrFixed2('wxshopPrice')"
                v-model.trim="ruleForm.wxshopPrice"
                placeholder="请输入商品售价"
                :disabled="isThird"
              ></el-input>
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0OrFixed2('markingPrice')"
                v-model.trim="ruleForm.markingPrice"
                placeholder="请输入划线价"
                :disabled="isThird"
              ></el-input>
            </el-form-item>
            <div id="way">3.销售限制</div>
            <el-form-item label="每人限购：">
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                v-model.trim="ruleForm.eachMemberPurchaseLimit"
                placeholder="请输入商品限购数额"
                :disabled="isThird"
              ></el-input>
              <div class="form-item-tip">
                默认-1表示不限购，若为一品多码商品时，限购为1表示多规格商品只能购买其中一个
              </div>
            </el-form-item>
            <el-form-item label="单笔订单数量上限：">
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                v-model.trim="ruleForm.singlePurchaseUp"
                placeholder="请输入商品单笔订单数量上限"
                maxLength="4"
                @input="filterGt0('singlePurchaseUp')"
              ></el-input>
              <div class="form-item-tip">
                默认空表示不限制商品单笔订单数量上限<span v-if="overseasSinglePurchaseUp">,最大上限{{overseasSinglePurchaseUp}}</span>
              </div>
            </el-form-item>
            <el-form-item label="是否允许加入购物车" prop="cartUsable">
              <el-tooltip
                class="item"
                effect="dark"
                content="一旦设置为禁止使用，则隐藏购物车按钮"
                placement="top"
              >
                <el-switch
                  v-model="ruleForm.cartUsable"
                  active-text="允许"
                  inactive-text="禁止"
                  active-color="#13ce66"
                  active-value="yes"
                  inactive-value="no"
                  :disabled="isThird"
                >
                </el-switch>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              label="起售数量："
              prop="sellsLimitMode"
              v-if="!ruleForm.skuModelList.length"
            >
              <el-radio-group
                v-model="ruleForm.sellsLimitMode"
                @change="sellsLimitModeChange"
                :disabled="isThird"
              >
                <el-radio label="singleAdd">
                  单个递加
                </el-radio>
                <el-radio label="circleAdd">
                  循环递加
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="起售数量限制："
              prop="sellsLimitNum"
              v-if="!ruleForm.skuModelList.length"
            >
              <el-input
                size="small"
                class="mr10 ipt"
                type="number"
                clearable
                v-model.trim="ruleForm.sellsLimitNum"
                placeholder="请输入起售数量限制"
                :disabled="isThird"
              ></el-input>
            </el-form-item>
            <el-form-item label="销量基数：" prop="salesBase">
              <el-input
                size="small"
                class="mr10 ipt"
                clearable
                v-model.trim="ruleForm.salesBase"
                placeholder="请输入商品销量基数"
                :disabled="isThird"
              ></el-input>
            </el-form-item>
            <el-form-item label="购买权限：">
              <el-select
                clearable
                v-model="ruleForm.memberGroupRelModelList"
                placeholder="请选择用户类型"
                size="small"
                filterable
                multiple
                :disabled="isThird"
              >
                <el-option
                  :label="v.groupAppellation"
                  :value="v.groupId"
                  v-for="(v, i) in memberLimitList"
                  :key="i"
                ></el-option>
              </el-select>
              <div class="form-item-tip">
                默认不限制，所有会员都可以购买；若限制会对客户身份进行限制，如PLUS会员专供
              </div>
            </el-form-item>
            <el-form-item label="开售时间：">
              <el-date-picker
                v-model="ruleForm.salesStartTime"
                type="datetime"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择开售时间"
                size="small"
                class="mr10"
              ></el-date-picker>
              <div class="form-item-tip">
                开售商品必须先上架，需商品在指定时间下，才能开售，否则上架状态下，显示开售倒计时
              </div>
            </el-form-item>
            <el-form-item label="要求留言：">
              <div class="flex item-center pointer" @click="addtionTime">
                <div class="add-wrapper mr10">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                添加字段
              </div>
              <ul>
                <li
                  class="flex item-center"
                  v-for="(v, i) in ruleForm.messageModelList"
                  :key="i"
                >
                  <el-select
                    v-model="v.messageId"
                    class="mr10"
                    size="small"
                    placeholder="请选择文本类型"
                  >
                    <el-option
                      :label="v.messageName"
                      :value="v.messageId"
                      v-for="(v, i) in wxShopSpuPostMessageList"
                      :key="i"
                    ></el-option>
                  </el-select>
                  <el-checkbox class="mr10" v-model="v.isMustWrite"
                    >必填</el-checkbox
                  >
                  <div class="minus-wrapper">
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteTime(i)"
                    ></span>
                  </div>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="上架时间：">
              <el-date-picker
                v-model="ruleForm.upStartTime"
                type="datetime"
                placeholder="请选择上架时间"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
              <div class="form-item-tip">上架后商品才可销售</div>
            </el-form-item>
            <el-form-item label="下架时间：">
              <el-date-picker
                v-model="ruleForm.downStartTime"
                type="datetime"
                placeholder="请选择下架时间"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="可售门店：">
              <shop-picker
                :available-shops="storeCode === '53010017032439' || storeCode === '42010216070190' ? dkMicroShopStoreList : microShopStoreList"
                :selected-shops.sync="selectedShops"
                :readonly="isThird"
                @change="handleShopPickerChange"
              />
            </el-form-item>

            <div id="delivery">4.配送信息</div>
            <el-form-item label="配送方式：" prop="deliveryMode">
              <el-checkbox-group
                v-model="ruleForm.deliveryMode"
                @change="deliveryModeChange"
                :disabled="isThird"
              >
                <el-checkbox
                  v-for="(v, i) in deliveryList"
                  :label="v.value"
                  :key="i"
                  :disabled="
                    ruleForm.isOverseas === 'yes' && v.value !== 'kdfh'
                  "
                  >{{ v.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="运费模板："
              prop="expressId"
              v-if="expressFlag"
            >
              <el-select
                size="small"
                v-model="ruleForm.expressId"
                filterable
                class="ml10"
                clearable
                placeholder="请选择运费模板"
                :disabled="isThird"
              >
                <el-option
                  :label="v.expressName"
                  :value="v.expressId"
                  v-for="(v, i) in expressList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <hm-filter-goods
      @setGoodsInfo="setGoodsInfo"
      :visible="dialogVisible"
      @close="dialogVisible = false"
    ></hm-filter-goods>
    <el-dialog
      title="导入商品信息"
      :close-on-click-modal="false"
      :visible.sync="importDialogVisible"
      width="600px"
    >
      <el-form label-width="80px">
        <el-form-item label="商品链接">
          <el-input size="small" type="text" v-model.trim="url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="importOutSource" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="importDialogVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="保税区列表"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBondedArea"
      width="600px"
    >
      <el-input
        size="small"
        style="width:300px"
        class="mr10 ipt"
        clearable
        v-model.trim="bondedAreaName"
        placeholder="请输入保税区名称"
      ></el-input>
      <el-button
        size="small"
        type="text"
        :disabled="bondedAreaName === ''"
        @click="addbondedAreaName(bondedAreaName)"
        >添加</el-button
      >
      <el-table
        class="mt10"
        stripe
        border
        :data="bondedAreaList"
        style="width: 100%"
        id="table"
        height="500"
        size="small"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="bondedAreaName"
          label="保税区名称"
        >
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="dialogVisibleBondedArea = false"
          type="info"
          size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="储值卡开启提示"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="prepayCardUsableDialogVisible"
      width="720px"
    >
      <div class="prepayCardUsableTips">
        <div><span class="mr10">•</span>如果禾苗系统的订单会同步到第三方的系统，请保持第三方系统中的商品与禾苗系统中一致，<span class="red">否则会造成储值卡的扣款无法同步</span></div>
        <div><span class="mr10">•</span>如果已出现未同步的数据，请到<span class="red">订单写入异常</span>中查看</div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="prepayCardUsableSet" size="small" type="primary"
          >了解风险并开启</el-button
        >
        <el-button @click="prepayCardUsableClose" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      noCircle
      noSquare
      :width="500"
      :height="500"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </el-card>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmFilterGoods from "@/components/HmFilterGoods";
import HmStep from "@/components/HmStep";
import { ShopPicker } from "@/components/shop-picker";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import {getLoginUser} from "@/utils/auth";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false;
export default {
  components: { myUpload, HmRichEditor, HmStep, HmFilterGoods, draggable, ShopPicker },
  data() {
    const patternCategoryFunc = function(rule, val, callback) {
      if (
        this.ruleForm.categoryRelModelList &&
        !this.ruleForm.categoryRelModelList.length
      ) {
        this.isShowCategoryErr = true;
        return callback(new Error("请选择商品分类"));
      }
      this.isShowCategoryErr = false;
      callback();
    }.bind(this);
    const patternFunc = function(rule, val, callback) {
      for (const v of this.ruleForm.skuModelList) {
        if (v.wxshopPrice === "" || v.stockNum === "") {
          return callback(new Error("请选择规格"));
        }
        if (!v.sellsLimitNum || v.sellsLimitNum == 0) {
          return callback(new Error("起售数量不能为0"));
        }
      }
      callback();
    }.bind(this);
    const patternAttributeFunc = function(rule, val, callback) {
      if (!this.ruleForm.spuAttributeList.length) {
        this.isShowAttributeErr = true;
        return callback(new Error("请选择分类"));
      }
      this.isShowAttributeErr = false;
      callback();
    }.bind(this);
    const patternDelay = function(rule, val, callback) {
      if (this.ruleForm.overstockSales === "open") {
        if (
          (this.ruleForm.afterPayDays === "" ||
            this.ruleForm.afterPayDays == null) &&
          !this.ruleForm.deliveryDeadline
        ) {
          return callback(new Error("请选择预购发货时间"));
        }
        callback();
      }
      callback();
    }.bind(this);
    const deliveryTypeFunc = (rule, val, callback) => {
      if (val === "bondedAreaDeliver") {
        if (this.ruleForm.bondedAreaId === "") {
          return callback(new Error("请选择保税区"));
        }
      }
      callback();
    };
    // typeId 父级Id
    // specId 子级Id
    return {
      showOverseas: false,
      expressFlag: true,
      bondedAreaName: "",
      prodPlaceList: [],
      bondedAreaList: [],
      dialogVisibleBondedArea: false,
      deliveryList: [
        {
          name: "门店自提",
          value: "mdzt"
        },
        {
          name: "快递发货",
          value: "kdfh"
        },
        {
          name: "同城配送",
          value: "tcps"
        }
      ],
      batchSettingPicList:[
        {
          value: "yes"
        },
      ],
      batchSettingPic: false,
      uploadShow: true,
      isSaving: false,
      importDialogVisible: false,
      selectOther: false,
      selectAll: false,
      selectedShops: [],
      deliveryMethodsList: [],
      wxShopSpuPostMessageList: [],
      url: "",
      dialogVisible: false,
      specification: "",
      currentStep: 1,
      allAttr: [],
      showGoodsSn: true,
      memberLimitList: [],
      steps: [
        {
          name: "添加基本信息",
          id: "base"
        },
        {
          name: "价格/库存信息",
          id: "specification"
        },
        {
          name: "销售限制",
          id: "way"
        }
        // {
        //   name: "配送信息",
        //   id: "delivery"
        // }
      ],
      isShowCategoryErr: true,
      isShowAttributeErr: true,
      scrollHeight: 0,
      showDetail: false,
      show: false,
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      spuSlideShowPicList: [],
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      selectedIndex: "",
      chargeType: "",
      expressList: [],
      categoryFunc: {
        multiple: true,
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = JSON.stringify({
                    wxshopCategoryId: v.wxshopCategoryId,
                    categoryName: v.categoryName
                  });
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = JSON.stringify({
                      wxshopCategoryId: v.wxshopCategoryId,
                      categoryName: v.categoryName
                    });
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      wxshopStockNum: "",
      wxshopPrice: "",
      currentSpec: null,
      uploadType: "",
      isThird: false,
      prepayCardUsableDialogVisible: false,
      storeCode: "",
      ruleForm: {
        sellsLimitMode:"singleAdd",
        sellsLimitNum:"1",
        isOverseas: "",
        prodPlaceId: "",
        deliveryType: "",
        bondedAreaId: "",
        feeRatio: "",
        salesBase: "",
        stockNum: "",
        memberGroupRelModelList: [],
        wxshopPrice: "",
        categoryRelModelList: [],
        spuType: "reality",
        spuSlideShowPicList: [],
        memberLaunchRefund: "",
        overstockSales: "open",
        overstockSalesMode: "date",
        deliveryDeadline: "",
        markingPrice: "",
        afterPayDays: "",
        sellingPoint: "",
        goodsSn: "",
        spuId: "",
        salesStartTime: "",
        couponUsable: "",
        netWeight: "",
        weightUnit: "g",
        eachMemberPurchaseLimit: -1,
        singlePurchaseUp: "",
        messageModelList: [],
        upStartTime: "",
        downStartTime: "",
        deliveryModelList: [],
        shopModelList: [],
        wxshopSpuName: "",
        skuModelList: [],
        brandId: "",
        spuAttributeList: [],
        basePrice: "",
        spuMainPic: "",
        sharePic: "",
        spuDetails: "",
        skuModelListCopy: [],
        deliveryMode: [],
        expressId: "",
        specificationList: [
          {
            specName: "",
            specId: "",
            specModels: []
          }
        ],
        prepayCardUsable: "yes",
        writePosUsable: "",
        cartUsable: "yes",
      },
      rules: {
        isOverseas: {
          required: true,
          message: "请选择是否海外商品",
          trigger: "change"
        },
        prodPlaceId: {
          required: true,
          message: "请选择原产地",
          trigger: "blur"
        },
        couponUsable: {
          required: true,
          message: "是否允许使用优惠券",
          trigger: "change"
        },
        deliveryType: [
          {
            required: true,
            message: "请选择发货方式",
            trigger: "change"
          },
          {
            required: true,
            validator: deliveryTypeFunc,
            trigger: "change"
          }
        ],
        feeRatio: {
          required: true,
          message: "请输入税费",
          trigger: "change"
        },
        goodsSn: {
          required: true,
          message: "请输入商品货号",
          trigger: "change"
        },
        deliveryMode: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur"
        },
        expressId: {
          required: true,
          message: "请选择运费模板",
          trigger: "blur"
        },
        stockNum: {
          required: true,
          message: "请输入商品库存",
          trigger: "blur"
        },
        overstockSalesMode: {
          validator: patternDelay,
          trigger: "blur"
        },
        wxshopSpuName: {
          required: true,
          message: "请输入商品名称",
          trigger: "blur"
        },
        category: {
          validator: patternCategoryFunc,
          trigger: "change"
        },
        brandId: {
          required: true,
          message: "请选择商品品牌",
          trigger: "change"
        },
        attribute: {
          validator: patternAttributeFunc,
          trigger: "blur"
        },
        wxshopPrice: {
          required: true,
          message: "请输入网店售价",
          trigger: "blur"
        },
        sellsLimitNum: {
          required: true,
          pattern: /^[1-9]\d*$/,
          message: "请输入大于0的正整数",
          trigger: "change"
        },
        salesBase: {
          required: false,
          pattern: /^([1-9]\d*|[0]{1,1})$/,
          message: "请输入正整数",
          trigger: "change"
        },
        skuModelList: [
          {
            validator: patternFunc,
            trigger: "blur"
          }
        ],
        actMemberUpperLimit: [
          { required: true, message: "请输入活动人数上限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      overseasSinglePurchaseUp: "",
      arounds: [{
          value: 'front',
          label: '前'
        }, {
          value: 'after',
          label: '后'
        }
        ],
      around:'after'
    };
  },
  computed: mapGetters([
    "specList",
    "allBrandList",
    "attrList",
    "microShopStoreList",
    "microShopGoodsDetails",
    "dkMicroShopStoreList"
  ]),
  watch: {
    microShopGoodsDetails(val) {
      if (val) {
        for (let key in val) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = val[key];
          }
        }
        if (!this.ruleForm.sellsLimitMode) {
          this.ruleForm.sellsLimitMode = "singleAdd";
        }
        this.isThird = val.isThird;
        this.around = val.deliveryDeadlineReverse==null?'after':val.deliveryDeadlineReverse
        this.ruleForm.memberGroupRelModelList = val.memberGroupRelModelList
          ? val.memberGroupRelModelList.map(v => v.groupId)
          : [];
        this.ruleForm.deliveryMode = val.deliveryMode
          ? JSON.parse(val.deliveryMode)
          : [];

        // 回显门店选择 - 将 shopModelList ID数组转换为 selectedShops 对象数组
        if (val.shopModelList && val.shopModelList.length > 0) {
          const shopList = this.storeCode === '53010017032439' || this.storeCode === '42010216070190'
            ? this.dkMicroShopStoreList
            : this.microShopStoreList;
          // 处理历史数据 "all" 的情况
          if (val.shopModelList.length === 1 && val.shopModelList[0] === 'all') {
            this.selectedShops = [...shopList];
          } else {
            // 根据ID匹配门店对象
            this.selectedShops = val.shopModelList.map(shopId => {
              const shop = shopList.find(s => s.shopId === shopId || s.id === shopId);
              return shop || { shopId: shopId, shopName: shopId };
            }).filter(s => s);
          }
        } else {
          this.selectedShops = [];
        }

        this.ruleForm.skuModelList.forEach(v => {
          v.bindState = v.bindState === "true";
          v.hidePic = v.hidePic === "true";
        });
        if (this.ruleForm.deliveryType === "overseasMail") {
          this.ruleForm.bondedAreaId = "";
        }
        if (this.ruleForm.deliveryMode.indexOf("kdfh") < 0) {
          this.expressFlag = false;
        } else {
          this.expressFlag = true;
        }
        this.ruleForm.categoryRelModelList = [];
        val.categoryRelModelList.forEach(v => {
          this.ruleForm.categoryRelModelList.push([
            // JSON.stringify({
            //   wxshopCategoryId: v.wxshopCategoryId,
            //   categoryName: v.categoryName
            // })
            JSON.stringify(v)
          ]);
        });
        setTimeout(() => {
          if (
            this.ruleForm.messageModelList &&
            this.ruleForm.messageModelList.length
          ) {
            this.ruleForm.messageModelList.forEach(v => {
              v.isMustWrite = v.isMustWrite === "true";
            });
          } else {
            this.ruleForm.messageModelList = [];
          }
          this.ruleForm.wxshopPrice = val.wxshopPrice;
          this.ruleForm.afterPayDays = val.afterPayDays;
          this.ruleForm.memberLaunchRefund = val.memberLaunchRefund;
          this.$refs.cascader.inputValue = val.categoryName;
          if (this.$refs.cascader) {
            this.$refs.cascader.presentText = val.categoryRelModelList

              .map(o => o.categoryName)
              .join(",");
          }
        }, 0);
      }
    },
    "ruleForm.overstockSalesMode": {
      handler() {
        if (this.ruleForm.overstockSalesMode !== "day") {
          this.ruleForm.afterPayDays = "";
        }
        this.ruleForm.deliveryDeadline = "";
      },
      deep: true
    },
    "ruleForm.spuType": {
      handler(val) {
        this.ruleForm.memberLaunchRefund = val === "virtual" ? "no" : "";
      },
      deep: true
    },
    // 监听门店列表变化，处理异步加载后的回显
    microShopStoreList: {
      handler(newList) {
        if (newList && newList.length > 0 && this.microShopGoodsDetails && this.microShopGoodsDetails.shopModelList) {
          const shopIds = this.microShopGoodsDetails.shopModelList;
          // 处理历史数据 "all" 的情况
          if (shopIds.length === 1 && shopIds[0] === 'all') {
            this.selectedShops = [...newList];
          } else {
            this.selectedShops = shopIds.map(shopId => {
              const shop = newList.find(s => s.shopId === shopId || s.id === shopId);
              return shop || { shopId: shopId, shopName: shopId };
            }).filter(s => s);
          }
        }
      },
      immediate: true
    },
    dkMicroShopStoreList: {
      handler(newList) {
        if (newList && newList.length > 0 && this.microShopGoodsDetails && this.microShopGoodsDetails.shopModelList) {
          const shopIds = this.microShopGoodsDetails.shopModelList;
          // 处理历史数据 "all" 的情况
          if (shopIds.length === 1 && shopIds[0] === 'all') {
            this.selectedShops = [...newList];
          } else {
            this.selectedShops = shopIds.map(shopId => {
              const shop = newList.find(s => s.shopId === shopId || s.id === shopId);
              return shop || { shopId: shopId, shopName: shopId };
            }).filter(s => s);
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.$store.dispatch("queryMicroShopGoodsDetails", {
      wxshopSpuId: this.$route.query.wxshopSpuId
    });
    this.queryDeliveryMethod();
    this.queryWxShopSpuPostMessage();
    this.queryMemberLimit();
    this.queryExpressList();
    this.queryProdPlaceList();
    this.queryBondedAreaList();
    this.getParamValueAllowNull();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
    });
    this.queryShowOverseas();
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
      // 导出excel
    outputExcelStores() {
      console.log('导出excel')
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商店名称",
          "商店编码"
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "门店模板");
      });
    },
    // 导入excel
    importfStore(e) {
      console.log('导入excel')
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          } else {
            isRequired = true
          }
          formatResult.push({
            shopName:v[0],
            shopId:v[1]
          });
        });
        if (isRequired) {

          let arrs = []
          formatResult.forEach(v => {
            arrs.push({shopCode:v.shopId})
          });;
          const { result } = await that.$store.dispatch("importFilterShopCodeList", arrs);
          if(result && result.successShopInfoModelList){
            that.ruleForm.shopModelList = result.successShopInfoModelList.map(e=>e.shopId);
          }
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商店信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    async queryShowOverseas() {
      const { result } = await this.$store.dispatch("queryShowOverseas", {
        code: "overseasShowState"
      });
      this.showOverseas = result && result.value === "open" ? true : false;
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    switchGoodsType() {
      if (this.ruleForm.spuType === "virtual") {
        this.ruleForm.afterPayDays = 0;
        this.ruleForm.overstockSalesMode = "day";
        this.ruleForm.prepayCardUsable = "no";
      } else {
        this.ruleForm.overstockSalesMode = "";
        this.ruleForm.afterPayDays = "";
        this.ruleForm.prepayCardUsable = "yes";
      }
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spuMainPic = jsonData.result;
        this.ruleForm.spuSlideShowPicList.unshift(jsonData.result);
        this.uploadShow = false;
      }
    },
    uploadSharePicSucc(jsonData){
      if (jsonData.code === 0) {
        this.ruleForm.sharePic = jsonData.result;
        this.uploadShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    isOverseasChange(val) {
      if (val === "yes") {
        this.ruleForm.deliveryMode = ["kdfh"];
      }
    },
    deliveryModeChange(val) {
      if (val.indexOf("kdfh") < 0) {
        this.expressFlag = false;
        // this.ruleForm.expressId = [];
      } else {
        this.expressFlag = true;
      }
    },
    async addbondedAreaName(bondedAreaName) {
      const { code } = await this.$store.dispatch("addBondedArea", {
        bondedAreaName
      });
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.bondedAreaName = "";
        this.queryBondedAreaList();
      }
    },
    async queryProdPlaceList() {
      const { result } = await this.$store.dispatch("queryProdPlaceList");
      this.prodPlaceList = result;
    },
    async queryBondedAreaList() {
      const { result } = await this.$store.dispatch("queryBondedAreaList");
      if (result) {
        this.bondedAreaList = result;
      }
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("delBondedArea", { id: row.id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            if (this.ruleForm.bondedAreaId === row.id) {
              this.ruleForm.bondedAreaId = "";
            }
            this.queryBondedAreaList();
          }
        });
      });
    },
    addBondedArea() {
      this.dialogVisibleBondedArea = true;
    },
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
        if (!this.ruleForm.expressId) {
          this.ruleForm.expressId = result.defaultTemplate.expressId;
        }
      }
      this.expressList.push(...result.templateList);
    },
    addwxshopSkuPic(v, type) {
      this.currentSpec = v;
      this.uploadType = type;
      this.show = true;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const isUploadVideo =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "mp4";
      if (
        this.ruleForm.spuSlideShowPicList.find(
          v => v.indexOf(".mp4") > -1 || v.indexOf(".MP4") > -1
        ) &&
        isUploadVideo
      ) {
        this.$message({
          message: "仅支持上传一个视频",
          type: "warning"
        });
        return false;
      }
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !isUploadVideo
      ) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp、mp4格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      let isSize = true;
      if (!isUploadVideo) {
        isSize = new Promise((resolve, reject) => {
          // let width = 750;
          // let height = 750;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          // img.onload = function() {
          //   let valid = img.width >= width && img.height >= height;
          //   valid ? resolve() : reject();
          // };
          img.src = _URL.createObjectURL(file);
          resolve();
        }).then(
          () => {
            return file;
          },
          () => {
            this.$message({
              message: "图片最低像素为（宽*高）：750*750",
              type: "warning"
            });
            return Promise.reject();
          }
        );
      } else {
        const limitSize = file.size / 1024 / 1024 <= 10;
        if (!limitSize) {
          this.$message({
            message: "上传视频大小不能超过10M!",
            type: "warning"
          });
          return false;
        }
      }
      return (
        (extension ||
          extension2 ||
          extension3 ||
          extension4 ||
          isUploadVideo) &&
        isSize
      );
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
    },
    handleShopPickerChange(shops) {
      // 判断是否全选
      const allShopCount = this.storeCode === '53010017032439' || this.storeCode === '42010216070190'
        ? this.dkMicroShopStoreList.length
        : this.microShopStoreList.length;
      this.selectAll = shops.length === allShopCount && allShopCount > 0;
      this.selectOther = shops.length > 0 && !this.selectAll;
      this.ruleForm.shopModelList = shops.map(s => s.shopId || s.id);
    },
    async queryMemberLimit() {
      const { result } = await this.$store.dispatch("queryMemberLimit", {
        pageSize: 9999999,
        pageNo: 1
      });
      if (result) {
        this.memberLimitList = result.records;
      }
    },
    async queryDeliveryMethod() {
      const { result } = await this.$store.dispatch("queryDeliveryMethod");
      this.deliveryMethodsList = result;
    },
    async queryWxShopSpuPostMessage() {
      const { result } = await this.$store.dispatch(
        "queryWxShopSpuPostMessage"
      );
      this.wxShopSpuPostMessageList = result;
    },
    setGoodsInfo(info) {
      for (let key in info) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = info[key];
        }
      }
      if (!this.ruleForm.sellsLimitMode) {
        this.ruleForm.sellsLimitMode = "singleAdd";
      }
      this.ruleForm.categoryRelModelList = [];
      info.skuModelList.forEach(v => {
        v.wxshopPrice = v.recommendedRetailPrice;
        v.stockNum = "";
        v.bindState = true;
        v.sellsLimitMode = "singleAdd";
        v.sellsLimitNum = "1";
        delete v.spuId;
        delete v.specIdGroup;
        delete v.specBarcode;
        delete v.recommendedRetailPrice;
      });
      this.ruleForm.wxshopPrice = info.recommendedRetailPrice;
      this.ruleForm.wxshopSpuName = info.spuName;
      this.ruleForm.spuSlideShowPicList = info.spuSlideShowPicList.map(
        v => v.slideshowPicPath
      );
      this.showGoodsSn = false;
    },
    setBindState(v) {
      if (typeof v.bindState === "string") {
        v.bindState = !(v.bindState === "true");
      } else {
        v.bindState = !v.bindState;
      }
      this.$forceUpdate();
    },
    addtionTime() {
      this.ruleForm.messageModelList.push({
        comments: "",
        type: "",
        messageId: this.wxShopSpuPostMessageList[0].messageId,
        isMustWrite: false
      });
    },
    deleteTime(i) {
      this.ruleForm.messageModelList.splice(i, 1);
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    async importOutSource() {
      // eslint-disable-next-line no-useless-escape
      const pattern = /^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?/;
      if (!pattern.test(this.url)) {
        this.$message({
          type: "warning",
          message: "请输入正确的url！"
        });
      } else {
        const { result } = await this.$store.dispatch("querySpiderImg", {
          url: encodeURIComponent(this.url)
        });
        // this.ruleForm.wxshopSpuName = result.name || "";
        this.ruleForm.spuMainPic = result.img || "";
        this.ruleForm.spuSlideShowPicList = result.imgList || [];
        if (result.detail) {
          let str = "";
          result.detail.map(v => {
            str += `<img src="${v}" />`;
          });
          this.ruleForm.spuDetails = str;
        }
        this.importDialogVisible = false;
        this.$message({
          type: "success",
          message: "导入成功"
        });
      }
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    addSpecification() {
      this.ruleForm.specificationList.push({
        specName: "",
        specId: "",
        specModels: []
      });
    },
    deleteSpecification(v, i) {
      this.ruleForm.skuModelList.forEach(o => {
        o.specValueList.forEach((p, index) => {
          v.attr.map(q => {
            if (p.specId === q.specId) {
              o.specValueList.splice(index, 1);
            }
          });
        });
      });
      this.ruleForm.specificationList.splice(i, 1);
    },
    batchSettingPicChange(e){
      if(e){
        console.log(e)
        this.ruleForm.skuModelList.map(v=>{
          v.firstspec = v.specValueList[0].specValue;
        })
        let skuModelListUnique = arrayUnique2(this.ruleForm.skuModelList, "firstspec");
        console.log("skuModelListUnique:",skuModelListUnique)
        this.ruleForm.skuModelList.forEach(v => {
          skuModelListUnique.forEach(o=>{
            if(v.specValueList[0].specValue===o.firstspec){
              if(v.skuId !== o.skuId){
                v.hidePic = true;
                console.log("v.skuId",v.skuId);
              }
            }
          })
        });
      }else{
        this.ruleForm.skuModelList.forEach(v => {
          v.hidePic = false;
        });
      }
      this.ruleForm.skuModelList = JSON.parse(JSON.stringify(this.ruleForm.skuModelList));
    },
    batchSetting() {
      this.ruleForm.skuModelList.map(v=>{
        v.firstspec = v.specValueList[0].specValue;
      })
      let skuModelListUnique = arrayUnique2(this.ruleForm.skuModelList, "firstspec");
      console.log("skuModelListUnique:",skuModelListUnique);
      this.ruleForm.skuModelList.forEach(v => {
        console.log(v);
        if(this.wxshopPrice!==""){
          v.wxshopPrice = this.wxshopPrice;
        }
        if(this.wxshopStockNum!==""){
          v.stockNum = this.wxshopStockNum;
        }
        if(this.batchSettingPic===true){
          skuModelListUnique.forEach(o=>{
            if(v.specValueList[0].specValue===o.firstspec){
              v.wxshopSkuPic = o.wxshopSkuPic;
            }
          })
        }
      });
      this.ruleForm.skuModelList.forEach(v => {
        v.hidePic = false;
      });
      this.batchSettingPic = false;
      this.$message({
        message: "操作成功",
        type: "success"
      });
    },
    setAttrList(v, index) {
      let len = this.ruleForm.specificationList.length;
      this.ruleForm.skuModelList = [];
      let resultLen = 1;
      this.ruleForm.specificationList.map(o => {
        resultLen = resultLen * o.attr.length;
      });
      if (len === 1) {
        for (let i = 0; i < resultLen; i++) {
          let specValueList = [];
          specValueList[index] = v.attr[i];
          this.ruleForm.skuModelList.push({
            specValueList,
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      } else if (len === 2) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            let arr2 = [];
            arr2.push(o, p);
            arr.push(arr2);
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      } else if (len === 3) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            this.ruleForm.specificationList[2].attr.map(q => {
              let arr2 = [];
              arr2.push(o, p, q);
              arr.push(arr2);
            });
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      }
    },
    switchSpecification(v, i) {
      const currentRow = this.specList.find(o => o.specId === v.specId);
      this.selectedIndex = i;
      v.attr = [];
      if (currentRow) {
        v.specModels = currentRow.specModels;
        v.specName = currentRow.specName;
      }
    },
    toUrl(url) {
      let routeUrl = this.$router.resolve({
        name: url
      });
      window.open(routeUrl.href, "_blank");
    },
    filterGt0OrFixed2ByData(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccesss(jsonData) {
      if (jsonData.code === 0) {
        // this.ruleForm.spuMainPic = jsonData.result;
        if (this.ruleForm.spuSlideShowPicList.length < 6) {
          this.ruleForm.spuSlideShowPicList.push(jsonData.result);
        } else {
          this.$message({
            type: "warning",
            message: "轮播图最多可设置6张！"
          });
        }
        this.uploadShow = false;

        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    cropUploadSuccess(jsonData) {
      if (this.uploadType === "wxshopSkuPic") {
        this.currentSpec.wxshopSkuPic = jsonData.result;
        this.uploadType = "";
        return;
      } else {
        if (this.show) {
          this.ruleForm.spuMainPic = jsonData.result;
          this.ruleForm.spuSlideShowPicList.push(jsonData.result);
        } else if (this.showDetail) {
          this.ruleForm.spuSlideShowPicList.push(jsonData.result);
        }
      }
    },
    cropUploadFail() {},
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          let categoryRelModelList = [];

          params.categoryRelModelList.forEach(v => {
            categoryRelModelList.push(JSON.parse(v[v.length - 1]));
          });

          // params.categoryRelModelList = params.categoryRelModelList.length
          //   ? params.categoryRelModelList[
          //       params.categoryRelModelList.length - 1
          //     ]
          //   : "";

          let memberGroupRelModelList = [];
          params.memberGroupRelModelList.forEach(v => {
            let index = this.memberLimitList.findIndex(o => o.groupId === v);
            if (index > -1) {
              memberGroupRelModelList.push({
                groupId: this.memberLimitList[index].groupId,
                groupName: this.memberLimitList[index].groupAppellation
              });
            }
          });
          params.memberGroupRelModelList = memberGroupRelModelList;

          params.categoryRelModelList = categoryRelModelList;
          delete params.specificationList;
          params = Object.assign(params, {
            spuSlideShowPicList: this.ruleForm.spuSlideShowPicList,
            wxshopSpuId: this.$route.query.wxshopSpuId
          });
          params.deliveryMode = JSON.stringify(this.ruleForm.deliveryMode);
          console.log("params.singlePurchaseUp:",params.singlePurchaseUp);
          console.log("this.overseasSinglePurchaseUp:",this.overseasSinglePurchaseUp);
          params.deliveryDeadlineReverse = this.around
          console.log("params.deliveryDeadlineReverse",params.deliveryDeadlineReverse)
          if(params.singlePurchaseUp && this.overseasSinglePurchaseUp && parseInt(params.singlePurchaseUp) > parseInt(this.overseasSinglePurchaseUp)){
            this.$message({
              message: "单笔订单数量上限设置最大为" + this.overseasSinglePurchaseUp,
              type: "warning"
            });
            return;
          }
          this.$store.dispatch("editMicroShopGoods", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
          this.$store.dispatch("importWxshopSpuInfo", {
            wxshopSpuId: this.$route.query.wxshopSpuId
          });
        } else {
          setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            if (isError[0].querySelector("input")) {
              isError[0].querySelector("input").focus();
            } else if (isError[0].querySelector("textarea")) {
              isError[0].querySelector("textarea").focus();
            }
          }, 1);
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.spuMainPic = "";
    },
    handleRemoveSharePic(){
      this.ruleForm.sharePic = "";
    },

    // 上传成功后的回调
    uploadSuccess(response) {
      this.ruleForm.spuMainPic = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.ruleForm.spuSlideShowPicList.splice(file, 1);
      } else {
        const index = this.ruleForm.spuSlideShowPicList.findIndex(
          v => v === file.response.result
        );
        this.ruleForm.spuSlideShowPicList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.ruleForm.spuSlideShowPicList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.ruleForm.spuSlideShowPicList[0];
      this.ruleForm.spuSlideShowPicList[0] = this.ruleForm.spuSlideShowPicList[
        i
      ];
      this.ruleForm.spuSlideShowPicList[i] = tmp;
      this.$forceUpdate();
    },
    setMainPic(i) {
      this.ruleForm.spuMainPic = this.ruleForm.spuSlideShowPicList[i];
    },
    sellsLimitModeChange(){

    },
    skuModelListSellsLimitModeChange(e){
      this.ruleForm.skuModelList.splice();
      console.log("e.ischecked:",e.ischecked);
    },
    prepayCardUsableChange(e){
      console.log(e);
      if(e=='yes'){
        this.prepayCardUsableDialogVisible = true;
      }
    },
    prepayCardUsableSet(){
      this.ruleForm.prepayCardUsable = "yes"
      this.prepayCardUsableDialogVisible = false;
    },
    prepayCardUsableClose(){
      this.ruleForm.prepayCardUsable = "no"
      this.prepayCardUsableDialogVisible = false;
    },
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "overseas_single_purchase_up"
      })
      if (code === "0") {
        console.log("result.paramValue",result.paramValue)
        this.overseasSinglePurchaseUp = result.paramValue || 9999;
      }
    },
  }
};
</script>
<style lang="scss">
.add-microshop-goods-container {
  .el-form-item__content {
    margin-left: 240px !important;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
  .btn {
    margin-left: 10px;
    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  color: #606266;
  font-weight: bold;
  font-size: 14px;
}

.table {
  margin-top: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  .table-control {
    padding: 0 29px;
    border-bottom: 1px solid #ddd;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
    color: #222;
  }
}

.specification-list {
  li {
    padding: 7px 10px;
    margin: 0;
    color: #666;
    background-color: #f8f8f8;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 20px 0;
  }
}

.priview {
  position: relative;
  width: 250px;
  height: 250px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.priviewSharePic{
  width: 250px;
  height: 200px;
}

.add-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  user-select: none;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.table-row {
  padding: 5px 0;
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}

.el-upload__tip {
  line-height: 30px;
}
.prepayCardUsableTips{
  font-size: 16px;
  line-height: 28px;
  .red{
    color: #e50065;
  }
}
</style>
